import { ErrorBoundary } from '@sentry/react';
import { CardBody } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useStatus } from '@/hooks/useStatus';
import { StatusTranslationKey } from '@/types/status';
import { CardHeightWrapper } from '../card/CardHeightWrapper';
import { ContactSupportStatusDescription } from '../support/ContactSupportCard';

interface ErrorCardProps {
  translationNameSpace: string;
  children: ReactNode;
  fallbackChildren?: ReactNode;
}

export const ErrorCard = ({ translationNameSpace, children, fallbackChildren }: ErrorCardProps) => {
  const status = useStatus(translationNameSpace, StatusTranslationKey.ERROR, {
    [StatusTranslationKey.ERROR]: <ContactSupportStatusDescription />,
  });
  return (
    <ErrorBoundary
      fallback={
        <CardHeightWrapper>
          <CardBody {...status}>{fallbackChildren}</CardBody>
        </CardHeightWrapper>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
